<template>
    <div class="hidden px-4 py-10 pb-12 mx-auto -mt-32 sm:block max-w-7xl sm:px-6 lg:px-8">
        <div class="overflow-hidden bg-white rounded-md shadow">
            <div class="py-4 bg-gray-200 shadow-sm rounded-t-md">
                <table class="table w-full text-sm text-indigo-700 uppercase table-fixed">
                    <thead>
                        <tr>
                            <th class="font-normal">
                                <svg
                                    @click="prev"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    class="inline w-8 h-8 border border-indigo-700 rounded-full cursor-pointer hover:text-indigo-500 hover:border-indigo-500"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                                        clip-rule="evenodd"
                                    ></path>
                                </svg>
                                <button
                                    @click="today"
                                    class="px-4 py-2 font-semibold bg-transparent border border-indigo-500 rounded hover:bg-indigo-500 hover:text-white hover:border-transparent"
                                >
                                    OGGI
                                </button>
                                <svg
                                    @click="next"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    class="inline w-8 h-8 border border-indigo-700 rounded-full cursor-pointer hover:text-indigo-500 hover:border-indigo-500"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                        clip-rule="evenodd"
                                    ></path>
                                </svg>
                            </th>
                            <th
                                v-for="(day, index) in daysOfWeek"
                                :key="index"
                                class="font-normal text-center border-l"
                            >
                                {{ day }}
                            </th>
                        </tr>
                    </thead>
                </table>
            </div>

            <div class="flex flex-col">
                <div class="py-2 -my-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                    <div class="inline-block min-w-full overflow-hidden align-middle border-b border-gray-200 shadow main-container">
                        <div class="scrollable">
                            <table class="w-full text-sm table-fixed calendar">
                                <tbody
                                    v-for="hour in hours"
                                    :key="hour"
                                >
                                    <tr class="h-12 border-b">
                                        <td
                                            class="pr-3 font-medium text-right day"
                                            rowspan="2"
                                        >{{ hour }}:00</td>
                                        <td
                                            v-for="( day, day_number ) in daysOfWeek"
                                            :key="day_number"
                                            @click="create( day_number, hour, 0 )"
                                            class="relative border-l"
                                        >
                                            <calendar-appointment
                                                v-for="appointment in currentAppointments(day_number, hour, 0)"
                                                :appointment="appointment"
                                                :key="appointment.id"
                                                @select="select"
                                                @remove="remove"
                                            >
                                            </calendar-appointment>
                                        </td>
                                    </tr>
                                    <tr class="h-12 border-b half-hour">
                                        <td
                                            v-for="( day, day_number ) in daysOfWeek"
                                            :key="day_number"
                                            @click="create( day_number, hour, 30 )"
                                            class="relative border-l"
                                        >
                                            <calendar-appointment
                                                v-for="appointment in currentAppointments(day_number, hour, 30)"
                                                :appointment="appointment"
                                                :key="appointment.id"
                                                @select="select"
                                                @remove="remove"
                                            >
                                            </calendar-appointment>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <calendar-modal
            v-if="openModal"
            :open="openModal"
            :appointment="appointment"
            @dismiss="openModal= false"
            @save="save"
        ></calendar-modal>
    </div>
</template>
<script type="text/javascript">
import { mapState } from "vuex";

import CalendarAppointment from "./CalendarAppointment";
import CalendarModal from "./CalendarModal";

export default {
    data: () => {
        return {
            appointment: {},
            showAllDay: false,
            startHour: 9,
            endHour: 19,
            hours: [],
            openModal: false
        };
    },

    components: {
        CalendarAppointment,
        CalendarModal
    },

    computed: {
        ...mapState("calendar", ["date", "appointments"]),
        daysOfWeek() {
            var tmpDate = window.moment(this.date).startOf("isoWeek");
            var days = [];
            days.push(tmpDate.format("ddd DD/MM/YYYY"));
            for (let interval = 0; interval < 4; interval++) {
                days.push(tmpDate.add(1, "d").format("ddd DD/MM/YYYY"));
            }
            return days;
        }
    },

    methods: {
        currentAppointments(day, hour, minutes = 0) {
            return _.filter(
                this.appointments,
                appointment =>
                    appointment.hour == hour &&
                    appointment.minutes == minutes &&
                    appointment.day == day + 1
            );
        },
        prev() {
            this.$store.commit(
                "calendar/DATE",
                window.moment(this.date.subtract(1, "w"))
            );
        },
        today() {
            this.$store.commit("calendar/DATE", window.moment());
        },
        next() {
            this.$store.commit(
                "calendar/DATE",
                window.moment(this.date.add(1, "w"))
            );
        },
        create(day, hour, minutes) {
            var tmp_date = window
                .moment(this.date)
                .startOf("isoWeek")
                .add(day, "d")
                .startOf("day");
            this.appointment = {
                date: tmp_date.format("YYYY-MM-DD"),
                start: tmp_date
                    .add(hour, "h")
                    .add(minutes, "m")
                    .format("HH:mm"),
                end: tmp_date.add("30", "m").format("HH:mm")
            };
            this.openModal = true;
        },
        select(data) {
            this.appointment = this.appointments.find(
                element => element.id == data.id
            );
            this.openModal = true;
        },
        save() {
            this.$store.dispatch("calendar/SAVE", {
                appointment: {
                    ...this.appointment,
                    year: this.date.format("Y"),
                    week: this.date.format("w")
                }
            });
            this.openModal = false;
        },
        remove(data) {
            this.$store.dispatch("calendar/DELETE", {
                appointment: this.appointments.find(
                    element => element.id == data.id
                ),
                week: {
                    year: this.date.format("Y"),
                    week: this.date.format("w")
                }
            });
        }
    },

    watch: {
        date() {
            this.$store.dispatch("calendar/WEEK", {
                year: this.date.format("Y"),
                week: this.date.format("w")
            });
        }
    },

    created() {
        for (let hour = this.startHour; hour <= this.endHour; hour++) {
            this.hours.push(hour);
        }
        if (this.date == null) {
            this.$store.commit("calendar/DATE", window.moment());
        }
    }
};
</script>
